import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { LoginPageComponent } from './admin-panel/login-page/login-page.component';
import { ForgetPasswordPageComponent } from './admin-panel/forget-password-page/forget-password-page.component';
import { DashboardPageComponent } from './admin-panel/dashboard-page/dashboard-page.component';
import { AuthGuardService } from './services/auth-guard.service';
import { HomeComponent } from './admin-panel/home/home.component';
import { ManageUserComponent } from './admin-panel/manage-user/manage-user.component';
import { CreateUserPageComponent } from './admin-panel/create-user-page/create-user-page.component';
import { ReportsPageComponent } from './admin-panel/reports-page/reports-page.component';

const appRoutes: Routes = [
  { path: 'home', component: HomeComponent },

  { path: '', component: LoginPageComponent },
  { path: 'login', component: LoginPageComponent },
  { path: 'forgot-password', component: LoginPageComponent },
  {
    path: 'dashboard',
    component: DashboardPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'user-management/manage-user',
    component: ManageUserComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'user-management/create-user',
    component: CreateUserPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'reports/:name/:api',
    component: ReportsPageComponent,
    canActivate: [AuthGuardService],
  },

  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes
      //   {
      //   preloadingStrategy: PreloadAllModules,
      //   anchorScrolling: 'enabled',
      //   scrollPositionRestoration: 'enabled',
      // }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
